import { render } from "./Stocks.vue?vue&type=template&id=f34dd7da&scoped=true&ts=true"
import script from "./Stocks.vue?vue&type=script&lang=ts"
export * from "./Stocks.vue?vue&type=script&lang=ts"

import "./Stocks.vue?vue&type=style&index=0&id=f34dd7da&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/medix_envato_v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f34dd7da"]])

export default __exports__